import { formatAmount, formatDate, raiseStageLabel, stageLabel } from '@workspace/seedforge-shared'
import type { PitchProfile } from '../types'

export function ProfileSummary({ profile }: { profile: PitchProfile }) {
  return (
    <div className="px-5 py-3">
      <div>
        <div className="flex items-center gap-2">
          <p className="text-sm font-bold text-white">{profile.startupName}</p>
          {profile.isFundraising && (
            <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-400/20 bg-emerald-400/10 px-2 py-0.5 text-[10px] font-medium text-emerald-400">
              <span className="relative flex size-1.5">
                <span className="absolute inline-flex size-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex size-1.5 rounded-full bg-emerald-400" />
              </span>
              Raising
              {profile.fundraisingStage && ` · ${raiseStageLabel(profile.fundraisingStage)}`}
              {profile.fundraisingAmount && ` · ${formatAmount(profile.fundraisingAmount)}`}
            </span>
          )}
        </div>
        <div className="mt-1 flex flex-wrap gap-2 text-[11px] text-muted-foreground">
          {profile.sector ? (
            <span>{profile.sector}</span>
          ) : (
            <span className="text-muted-foreground/50">No sector</span>
          )}
          {profile.productStage ? (
            <>
              <span className="text-border">&middot;</span>
              <span>{stageLabel(profile.productStage)}</span>
            </>
          ) : (
            <>
              <span className="text-border">&middot;</span>
              <span className="text-muted-foreground/50">No stage</span>
            </>
          )}
          {profile.location ? (
            <>
              <span className="text-border">&middot;</span>
              <span>{profile.location}</span>
            </>
          ) : (
            <>
              <span className="text-border">&middot;</span>
              <span className="text-muted-foreground/50">No location</span>
            </>
          )}
          {profile.foundingDate ? (
            <>
              <span className="text-border">&middot;</span>
              <span>Founded {formatDate(profile.foundingDate)}</span>
            </>
          ) : (
            <>
              <span className="text-border">&middot;</span>
              <span className="text-muted-foreground/50">No founding date</span>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
